"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BarOptions = /** @class */ (function () {
    function BarOptions() {
        this.width = 500;
        this.height = 500;
        this.margin = { top: 20, right: 0, bottom: 30, left: 40 };
        this.data = Promise.resolve([]);
    }
    return BarOptions;
}());
exports.default = BarOptions;
